export const S3_DIRECTORY_NAMES = {
  /** 一見して危険かどうかの外観の調査画像 */
  EXTERIOR: 'exterior',
  /** 隣接建築物・周辺地盤の破壊による危険の調査画像 */
  SURROUNDING: 'surrounding',
  /** 構造躯体の不動沈下の調査画像 */
  DIFFERENTIAL_SETTLEMENT: 'differentialSettlement',
  /** 基礎の調査画像 */
  BASICS: 'basics',
  /** 建築物の 1 階の傾斜の調査画像 */
  FIRST_FLOOR_SLOPE: 'firstFloorSlope',
  /** 壁の調査画像 */
  WALL: 'wall',
  /** 腐食・蟻害の有無の調査画像 */
  CORROSION_OR_TERMITE: 'corrosionOrTermite',
  /** 不同沈下による建築物全体の傾斜の調査画像 */
  SETTLEMENT_SLOPE_STEEL: 'settlementSlopeSteel',
  /** 瓦の調査画像 */
  ROOF_TILE: 'roofTile',
  /** 窓枠・窓ガラスの調査画像 */
  WINDOW_FRAME: 'windowFrame',
  /** 外装材（モルタル、タイル・石張り等）の調査画像 */
  EXTERIOR_WET_MATERIAL: 'exteriorWetMaterial',
  /** 外装材（ALC 板・PC 板・金属・ブロック等）の調査画像 */
  EXTERIOR_DRY_MATERIAL: 'exteriorDryMaterial',
  /** 看板･機器類の調査画像 */
  SIGNBOARD: 'signboard',
  /** 屋外階段の調査画像 */
  OUTDOOR_STAIRS: 'outdoorStairs',
  /** 不同沈下による建築物全体の傾斜の調査画像 */
  SETTLEMENT_SLOPE: 'settlementSlope',
  /** 傾斜を生じた階の上の階数の調査画像 */
  ABOVE_SLOPE_FLOOR_LEVEL: 'aboveSlopeFloorLevel',
  /** 建築物全体又は一部の傾斜の調査画像 */
  SLOPE: 'slope',
  /** 部材の座屈の有無の調査画像 */
  BUCKLING: 'buckling',
  /** 筋違の破断率の調査画像 */
  BRACE: 'brace',
  /** 柱梁の接合部及び継手の破壊の調査画像 */
  PILLAR_BEAM_JOINT: 'pillarBeamJoint',
  /** 柱脚の破損の調査画像 */
  PILLAR_BASE: 'pillarBase',
  /** 腐食の有無の調査画像 */
  CORROSION: 'corrosion',
  /** 屋根材 */
  ROOF_MATERIAL: 'roofMaterial',
  /** 損傷度 Ⅲ 以上の損傷部材の有無の調査画像 */
  PARTS_DAMAGE_GTE_3: 'partsDamageGte3',
  /** 地盤破壊による建築物全体の沈下の調査画像 */
  GROUND_DESTRUCTION_SETTLEMENT: 'groundDestructionSettlement',
  /** 柱の被害 被害最大の階の調査画像 */
  PILLAR_DAMAGE_FLOOR: 'pillarDamageFloor',
  /** 損傷度 Ⅴ の柱本数/調査柱本数の調査画像 */
  PILLAR_DAMAGE_5: 'pillarDamage5',
  /** 損傷度 Ⅳ の柱本数/調査柱本数の調査画像 */
  PILLAR_DAMAGE_4: 'pillarDamage4',
  /** その他の調査画像 */
  OTHER_ITEM: 'otherItem',
  /** 判定ステッカーの画像 */
  OVERALL_RESULT: 'overallResult'
} as const
